<template>
  <div class="pricingCard mt-5 pt-5">
    <b-container>
      <b-row>
        <b-col class="my-5 py-5 d-none d-md-block" style="color: #ffffff; text-align: center">
          <h2 style="font-size: 36px; font-weight: 400" >Choose the Plan That's Right For You</h2>
          <blockquote class="lead blockquote">
            Enjoy a free month trial on us. Cancel anytime.</p>
          </blockquote>
        </b-col>
        <b-col class="pb-4 d-md-none" style="color: #ffffff; text-align: center">
          <h2 style="font-size: 22px; font-weight: 400" >Choose the Plan That's Right For You</h2>
          <blockquote class="lead blockquote" style="font-size: 16px">
            Enjoy a free month trial on us. Cancel anytime.</p>
          </blockquote>
        </b-col>
      </b-row>

      <b-row class="pb-4">
        <b-col>
          <b-card v-for="pod in pods" class="mb-2" style="text-align: center">
            <b-row class="mx-0 pb-4" style="text-align: center">
              <b-col class="text-light available"
              v-for="item in topTableItems">
                {{ item[pod.id]}}
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <h1 style="font-size: 26px">
                  {{ pod.title }}
                </h1>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <p class="card-text">
                  {{ pod.description }}
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <h3 style="font-size: 30px">
                  {{ pod.price }}
                </h3>
                <p>
                  per user/month
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-button :href="pod.href" target="_blank" :variant="pod.btnVariant">
                  {{ pod.offer }}
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p>
                  <a href="#">
                    {{ pod.purchase }}
                  </a>
                </p>
              </b-col>
            </b-row>

            <b-row>
              <b-col v-b-toggle="pod.id" style="color: #007bff">
                <font-awesome-icon :icon="iconPlusCircle" />
                <span style="font-style: italic">
                  See Features
                </span>
              </b-col>
            </b-row>

            <b-row class="pt-3">
              <b-col>
                <b-collapse :id="pod.id">
                  <div v-for="feature in pricingFeatures" style="font-weight: bold">
                      <p v-if="feature[pod.id] === true">{{ feature.feature }}</p>
                  </div>
                </b-collapse>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
export default {
    name: 'pricingLayoutMobile',
    components: {
      FontAwesomeIcon
    },
    data () {
      return {
  	    iconPlusCircle: faPlusCircle,
        }
    },
  computed: {
    pods() {
      return this.$store.state.pods;
    },
    pricingFeatures() {
      return this.$store.state.pricingFeatures;
    },
    pricingFields() {
      return this.$store.state.pricingFields;
    },
    topTableItems() {
      return this.$store.state.topTableItems;
    },
    topTableFields() {
      return this.$store.state.topTableFields;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pricingCard {
  background-image: url("../assets/purple_plexus_wide.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.card-body {
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
  }
</style>

<!-- Table styles not scoped -->
<style>
.available {
  background-color: #28a745 !important;
}
</style>
